import { IApplicationError } from '../shared/application-error';

export interface ParticipantTokenValidationModel {
    tokenValue: string;
    hasPassword: boolean;
    tokenValidationErrorType: number;
    locale: string;
    applicationError: IApplicationError | null;
    participantName: string;
    languageId?: number;
    otac: string;
    participantIdentifier: string;
}
